// Shared constants for column management components
export const GROUP_HEADING_GAP = '0.5rem';
export const ICON_SIZE = '1.5rem';

// Grid layout constants
export const GRID_COLUMNS = 2;
export const ITEM_HEIGHT = '2rem';
export const ITEM_GAP = '0.5rem';

// Animation constants
export const TRANSITION_DURATION = '0.2s';
export const ROTATION_DEGREES = -90;

export const RESTRICTED_COLUMN_GROUPS = {
  RUBRICS: 'Rubric',
  FINANCIALS: 'Financials',
  KPIS: 'KPIs',
} as const;
